import { render, staticRenderFns } from "./FiltersButton.vue?vue&type=template&id=c92b24fe&scoped=true&"
import script from "./FiltersButton.vue?vue&type=script&lang=js&"
export * from "./FiltersButton.vue?vue&type=script&lang=js&"
import style0 from "./FiltersButton.vue?vue&type=style&index=0&id=c92b24fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92b24fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c92b24fe')) {
      api.createRecord('c92b24fe', component.options)
    } else {
      api.reload('c92b24fe', component.options)
    }
    module.hot.accept("./FiltersButton.vue?vue&type=template&id=c92b24fe&scoped=true&", function () {
      api.rerender('c92b24fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/desktop/CommonFilters/FiltersButton.vue"
export default component.exports